// extracted by mini-css-extract-plugin
export default {"report":"reports_report__LIjg5"};